module.exports = __webpack_public_path__ + "static/img/tb.3d18eb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tb.png
// module id = BwPK
// module chunks = 1